<!--
 * @Descripttion: 
 * @version: v1.0
 * @Author: wangxiaoyun
 * @Date: 2022-05-05 09:31:50
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-18 18:02:54
-->
<template>
  <div class="myDialog">
    <div class="login">
      <!-- 登录 -->
      <div class="loginCenter" v-if="toggle == 1">
        <div class="close" @click="$store.commit('changeDialog', false)">
          <i class="el-icon-close"></i>
        </div>
        <div class="title">登 录</div>
        <el-form :model="loginForm" class="demo-form-inline" label-width="30px">
          <el-form-item label>
            <template slot="label">
              <i class="el-icon-user"></i>
            </template>
            <el-input
              type="number"
              v-model="loginForm.username"
              placeholder="请输入登录手机号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="loginForm.password"
              placeholder="请输入8位密码"
              type="password"
              show-password
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
              maxlength="8"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <i class="el-icon-picture-outline"></i>
            </template>
            <div style="display: flex;align-items: center;">
              <el-input
                v-model="loginForm.captcha"
                placeholder="请输入验证码"
                type="text"
                maxlength="8"
              ></el-input>
              <img :src="captchaPath" @click="getCaptcha" style="margin: 0; height: .4rem; cursor: pointer;"/>
              </div>
              <!-- oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')" -->
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="onSubmit">登录</el-button>
        <div class="loginFooter loginFooter-flex">
          <span @click="changeToggleToForgotPassword">忘记密码</span>
          <span @click="changeToggleToregister">立即注册</span>
        </div>
      </div>
      <!-- 注册 -->
      <div class="loginCenter" v-if="toggle == 2">
        <div class="close" @click="$store.commit('changeDialog', false)">
          <i class="el-icon-close"></i>
        </div>
        <div class="title">注 册</div>
        <el-form
          :model="registerForm"
          class="demo-form-inline"
          label-width="60px"
          ref="registerForm"
          :rules="registerFormRules"
        >
          <el-form-item
            style="
              border-bottom: none !important;
              margin-bottom: 15px !important;
            "
            class="userType"
          >
            <!-- <template slot="label">
              <i class="el-icon-user"></i>
            </template> -->
            <!-- <el-select
              v-model="registerForm.userRoleId"
              placeholder="请选择用户性质"
            >
              <el-option label="个人用户" value="2"></el-option>
              <el-option label="企业用户" value="4"></el-option>
                
            </el-select> -->
            <el-radio v-model="registerForm.userRoleId" label="2"
              >个人用户</el-radio
            >
            <el-radio v-model="registerForm.userRoleId" label="4"
              >企业用户</el-radio
            >
          </el-form-item>
          <el-form-item label>
            <template slot="label">
              <i class="el-icon-user"></i>
            </template>
            <el-input
              v-model="registerForm.nickname"
              placeholder="请输入用户名称"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="phone">
            <template slot="label">
              <i class="el-icon-phone"></i>
            </template>
            <el-input
              v-model="registerForm.phone"
              placeholder="请输入手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <div>
            <el-form-item label prop="verificationCode">
              <template slot="label">
                <img
                  width="17"
                  src="@/assets/image/index/verifiIocn.png"
                  style="position: relative; top: 5px"
                  alt
                />
              </template>
              <div class="verificationCode-inner">
                <div class="verificationCode-inner-left">
                  <el-input
                    v-model="registerForm.verificationCode"
                    placeholder="请输入验证码"
                    type="number"
                    oninput="if(value.length > 6) value=value.slice(0, 6)"
                  ></el-input>
                </div>

                <div class="verificationCode-inner-right">
                  <el-button
                    class="verificationBtn"
                    :disabled="valiBtnDisabled"
                    @click="getCode"
                    >{{ valiBtn }}</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label v-if="registerForm.userRoleId == 4">
            <template slot="label">
              <i class="el-icon-user"></i>
            </template>
            <el-input
              v-model="registerForm.deptName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>

          <el-form-item label>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="registerForm.passowrd"
              placeholder="请输入8位密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="registerForm.passowrd2"
              placeholder="请确认密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
          <!-- 省市区 -->
          <el-form-item v-if="registerForm.userRoleId == 4">
            <template slot="label">
              <i class="el-icon-location-outline"></i>
            </template>
            <el-cascader
              style="width: 100%"
              :options="options"
              v-model="selectedOptions"
              @change="addressChoose"
              placeholder="请选择地址"
            ></el-cascader>
          </el-form-item>
          <el-form-item label v-if="registerForm.userRoleId == 4">
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="registerForm.organizationCode"
              placeholder="请输入组织机构代码"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="registerForm.userRoleId == 4"
            style="position: relative"
          >
            <template slot="label">
              <i class="el-icon-picture-outline"></i>
            </template>
            <el-input :placeholder="placeholder" type="text" readonly>
              <template slot="suffix">
                <el-upload
                  class="upload-demo"
                  :action="action"
                  accept=".jpg, .png"
                  list-type="picture-card"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                >
                  <div style="color: #2579bf; height: 30px" class="upLoad">
                    上传+
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" style="z-index: 999">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="dialogOpenBox">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <span
            style="color: #2579bf; cursor: pointer"
            class="dialogOpen"
            @click="show = true"
            >《注册协议》</span
          >
        </div>
        <el-button type="primary" @click="register">注册</el-button>
        <span
          class="gotoLogin"
          style="cursor: pointer"
          @click="changeToggleToLogin"
          >去登录</span
        >
      </div>
      <!-- 忘记密码 -->
      <div class="loginCenter" v-if="toggle == 3">
        <div class="close" @click="$store.commit('changeDialog', false)">
          <i class="el-icon-close"></i>
        </div>
        <div class="title">忘记密码</div>
        <el-form
          :model="forgetPasswordForm"
          class="demo-form-inline"
          label-width="24px"
          ref="forgetPasswordForm"
          :rules="forgetPasswordFormRules"
        >
          <div>
            <el-form-item label prop="phone">
              <template slot="label">
                <i class="el-icon-phone"></i>
              </template>
              <el-input
                v-model="forgetPasswordForm.phone"
                placeholder="请输入手机号"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label prop="verificationCode">
              <template slot="label">
                <img
                  width="17"
                  src="@/assets/image/index/verifiIocn.png"
                  style="position: relative; top: 5px"
                  alt
                />
              </template>
              <div class="verificationCode-inner">
                <div class="verificationCode-inner-left">
                  <el-input
                    v-model="forgetPasswordForm.verificationCode"
                    placeholder="请输入验证码"
                    type="number"
                    oninput="if(value.length > 6) value=value.slice(0, 6)"
                  ></el-input>
                </div>

                <div class="verificationCode-inner-right">
                  <el-button
                    class="verificationBtn"
                    :disabled="valiBtnDisabled"
                    @click="getCode"
                    >{{ valiBtn }}</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label prop="password">
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="forgetPasswordForm.password"
              placeholder="请输入8位密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label prop="password2">
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="forgetPasswordForm.password2"
              placeholder="请确认密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="forgetPassword">确定</el-button>
        <span
          class="gotoLogin"
          style="cursor: pointer"
          @click="changeToggleToLogin"
          >去登陆</span
        >
      </div>
    </div>
    <el-dialog title="⽹站⽤户注册协议" :visible.sync="show" width="50%">
      <div class="dialogContent">
        <h4>尊敬的用户您好</h4>
        <span>
          尊敬的用户您好，欢迎您访问 青岛环境医院
          ⽹站（以下简称：⽹站）。在您注册成为⽹站会员之前，请您务必认真阅读和理解《⽹站⽤户注册协议》（以下简称：协议）中所有的条款。您须完全同意协议中所有的条款，才可以注册成为本⽹站的会员，使⽤⾥⾯的服务。您在⽹站的注册和操作均将被视为是您对协议所有条款及内容的⾃愿接受。
        </span>
        <h4>⼀、声明</h4>
        <span
          >（⼀）⽹站内在线产品的所有权及运营权归
          青岛市环境保护科学研究院所有。</span
        >
        <span
          >（⼆）您在⽹站进⾏注册时，⼀旦点击“我接受”按钮，即表⽰为您已⾃愿接受协议中所有的条款和内容（包括填写姓名、联系方式等）。</span
        >
        <span
          >（三）协议条款的效⼒范围仅限于本⽹站，您在⽹站的⾏为均受协议的约束。</span
        >
        <span
          >（四）您使⽤⽹站服务的⾏为，即被视为您已知悉本⽹站的相关公告并同意。</span
        >
        <span>
          （五）根据市场经营情况的变化，本站有权随时更改本注册用户协议及相关服务规则。修改本注册用户协议时，本站将于相关页面公告修改的事实，有权不对注册用户进行个别通知。注册用户应该在每次登录前查询网站的相关公告，以了解注册用户协议及其他服务规则的变化。
        </span>
        <span>
          （六）本⽹站有权在未提前通知您的情况下修改、暂停⽹站部分或全部的服务，且不承担由此产⽣来⾃您和第三⽅的任何责任。
        </span>
        <span
          >（七）若注册用户不同意本注册用户协议或相关服务规则，或者不同意本站作出的修改，注册用户可以主动停止使用本站提供的产品和服务，如果在本站修改协议或服务规则后，注册用户仍继续使用本站提供的产品和服务，即表示注册用户同意本站对本注册用户协议及相关服务规则所做的所有修改。由于注册用户在注册用户协议变更后因未熟悉公告规定而引起的损失，本站将不会承担任何责任。</span
        >
        <span>
          （八）本⽹站提供免费注册服务，您的注册均是⾃愿⾏为，注册成功后，您可以得到⽹站更加完善的服务。
        </span>
        <span>
          （九）您注册成为会员后账户和密码如有灭失，不会影响到您已办理成功业务的效⼒，本⽹站可恢复您的注册账户及相关信息但不承担除此以外的其它任何责任。
        </span>
        <span>
          （十）关于注册用户隐私的具体协议以本站的隐私声明为准。如果注册用户提供的资料包含有不正确的信息，本站保留结束注册用户使用网络服务资格的权利。
        </span>
        <span>
          （十一）本站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或注册用户传送的信息有所变动。这些行为都有可能会导致本站的形象受损，所以本站事先提出这种损害的可能性。
        </span>
        <h4>⼆、⽤户管理</h4>
        <span>
          （⼀）您在本⽹站的所有⾏为都须遵守中国的法律法规，您不得利⽤本⽹站提供的服务制作、复制、发布、传播含有下列内容的信息：
        </span>
        <span class="smallInfo">1、反对宪法基本原则的；</span>
        <span class="smallInfo"
          >2、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统⼀的；</span
        >
        <span class="smallInfo">3、损害国家荣誉和利益的；</span>
        <span class="smallInfo"
          >4、煽动民族仇恨、民族歧视、破坏民族团结的；</span
        >
        <span class="smallInfo"
          >5、破坏国家宗教政策，宣扬邪教和封建迷信的；</span
        >
        <span class="smallInfo"
          >6、散布谣⾔、扰乱社会秩序、破坏社会稳定的；</span
        >
        <span class="smallInfo"
          >7、散布淫秽、⾊情、赌博、暴⼒、凶杀、恐怖内容或者教唆犯罪的；</span
        >
        <span class="smallInfo">8、侮辱或者诽谤他⼈，侵害他⼈合法权益的；</span>
        <span class="smallInfo">9、含有法律、行政法规禁止的其他内容的。</span>
        <span
          >（⼆）您在本⽹站的⾏为，还必须符合其它国家和地区的法律规定以及国际法的有关规定。</span
        >
        <span>（三）不得利⽤本⽹站从事以下活动：</span>
        <span class="smallInfo"
          >1、未经允许，进⼊计算机信息⽹络或者使⽤计算机信息⽹络的资源的；</span
        >
        <span class="smallInfo"
          >2、未经允许，对他⼈计算机信息⽹络的功能进⾏删除、修改或增加的；</span
        >
        <span class="smallInfo"
          >3、未经允许，对他⼈计算机信息⽹络中存储、处理或者传输的数据和应⽤程序进⾏删除、修改或者增加的；</span
        >
        <span class="smallInfo"
          >4、故意制作、故意传播计算机病毒等破坏性程序的；</span
        >
        <span class="smallInfo"
          >5、不得利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息。</span
        >
        <span class="smallInfo">6、其他危害计算机信息⽹络安全的。</span>
        <span>（四）遵守本⽹站其他规定和程序：</span>
        <span>1、您对⾃⼰在本⽹站中的⾏为和操作承担全部责任；</span>
        <span>
          2、您承担责任的形式包括但不仅限于，对受到侵害者进⾏赔偿、在本⽹站⾸先承担了因您的⾏为导致的⾏政处罚或侵权损害赔偿责任后，您应给予本⽹站的等额赔偿，本网站因您的⾏为所支付的各项实现债权的费用由您承担；
        </span>
        <span>
          3、如果本⽹站发现您传输的信息含有本协议所规定的内容，本⽹站有权在不通知您的情况下采取包括但不仅限于向国家有关机关报告、保存有关记录、删除该内容及链接地址、关闭服务器、暂停您账号的操作权限、停⽌向您提供服务等措施。
        </span>
        <h4>三、注册会员权利和义务</h4>
        <span>（⼀）注册会员有权⽤本⽹站提供的服务功能。</span>
        <span>
          （⼆）注册会员同意遵守包括但不仅限于《中华⼈民共和国保守国家秘密法》、《中华⼈民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联⽹信息服务管理办法》、《计算机信息网络国际联网安全保护管理办法》等在内的法律、法规。
        </span>
        <span
          >（三）您注册时有义务提供完整、真实、的个⼈信息，信息如有变更，应及时更新。</span
        >
        <span>
          （四）您成为注册会员须妥善保管⽤户名和密码，⽤户登录后进⾏的⼀切活动均视为是您本⼈的⾏为和意愿，您负全部责任。此外，您若发现有任何⾮法使⽤您的⽤户账号或安全漏洞的情况，应⽴即通告本⽹站，否则造成的任何损失由您个人承担。
        </span>
        <span
          >（五）您在使⽤本⽹站服务时，同意且接受本⽹站提供的各类信息服务。</span
        >
        <span>（六）您使⽤本⽹站时，禁⽌有以下⾏为：</span>
        <span>
          1、上载、张贴、发送电⼦邮件或以其他⽅式传送含有违反国家法律、法规的信息或资料，这些资料包括但不仅
          限于资讯、资料、⽂字、软件、⾳乐、照⽚、图形、等（下同）；
        </span>
        <span
          >2、散布淫秽、⾊情、赌博、暴⼒、凶杀、恐怖或者教唆犯罪的资料；</span
        >
        <span
          >3、冒充任何个⼈或机构，或以虚伪不实的⽅式误导他⼈以为其与任何⼈或任何机构有关；</span
        >
        <span
          >4、以党和国家领导人或其他名人的真实姓名、字、号、艺名、笔名注册；</span
        >
        <span>5、请勿注册和使用不文明、不健康的名字；</span>
        <span
          >6、传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</span
        >
        <span
          >7、通过本⽹站⼲扰、破坏或限制他⼈计算机软件、硬件或通讯设备功能的⾏为；</span
        >
        <span>8、通过本⽹站跟踪或以其他⽅式骚扰他⼈。</span>
        <h4>四、⽤户隐私</h4>
        <span>
          （一）我们承诺，对您个⼈的信息和隐私的安全承担保密义务。未经您授权或同意，本⽹站不会将您的个⼈资料信息泄露给第三⽅，但以下情况除外，且本⽹站不承担任何责任：
        </span>
        <span
          >1、政府单位按照中华⼈民共和国的法律、⾏政法规、部门规章、司法解释等规范性法律⽂件（统称“法律法规”），要求本⽹站提供的。</span
        >
        <span
          >2、由于您个人行为（如将⽤户和密码告知或泄露给他⼈等）导致的个⼈资料泄露的。</span
        >
        <span
          >3、包括但不仅限于⿊客攻击、计算机病毒侵⼊或发作、政府管制等不可抗⼒⽽造成的⽤户个⼈资料泄露、丢失、被盗⽤或被篡改等。</span
        >
        <span
          >4、为免除他⼈正在遭受威胁到其⽣命、⾝体或财产等⽅⾯的危险，所采取的措施。</span
        >
        <span
          >5、本⽹站会与其他⽹站链接，但不对其他⽹站的隐私政策及内容负责。</span
        >
        <span>6、由于您⾃⾝的疏忽、⼤意等过错所导致的。</span>
        <span
          >7、您在本⽹站的有关记录有可能成为您违反法律法规和本协议的证据。</span
        >
        <span>
          （二）本网站可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本网站同等的保护用户隐私的责任，则本网站可将用户的注册资料等提供给该第三方。
        </span>
        <span
          >（三）在不透露单个用户隐私资料的前提下，本网站有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</span
        >
        <h4>五、知识产权</h4>
        <span>
          本⽹站所有的域名、商号、商标、⽂字、视像及声⾳内容、图形及图像均受有关所有权和知识产权法律的保护，
          未经本⽹站事先以书⾯明确允许，任何个⼈或单位，均不得进⾏复制和使⽤。
        </span>
        <h4>六、免责声明</h4>
        <span>
          1、用户明确同意其使用本网站网络服务所存在的风险将完全由其自己承担；因其使用本网站网络服务而产生的一切后果也由其自己承担，本网站对用户不承担任何责任。
        </span>

        <span>
          2、
          本网站不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
        </span>

        <h4>七、法律适⽤</h4>
        <span>
          （⼀）协议由本⽹站的所有⼈负责修订，并通过本⽹站公布，您的注册⾏为即被视为您⾃愿接受协议的全部条款，受其约束。
        </span>
        <span
          >（⼆）协议的⽣效、履⾏、解释及争议的解决均适⽤中华⼈民共和国法律。</span
        >
        <span
          >（三）您使⽤⽹站提供的服务如产⽣争议，原则上双⽅协商解决，协商不成可向青岛市市南区人民法院提起诉讼。</span
        >
        <span
          >（四）协议的条款如与法律相抵触，本⽹站可进⾏重新解析、修订，⽽其他条款则保持对您产⽣法律效⼒和约束。</span
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
import { JSEncrypt, setPublicKey, encrypt } from "@/assets/js/jsencrypt.min.js";
export default {
  name: "dialogLogin",
  props: {},
  data() {
    // 验证码手机号验证
    var checkPhone = (rule, value, callback) => {
      const reg =
        /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[19])[0-9]{8}$/;
      if (reg.test(value)) {
        return callback();
      }
      callback("请输入合法的手机号");
    };
    // 验证码密码验证

    var checkPassword = (rule, value, callback) => {
      const reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8}$/;
      if (reg.test(value)) {
        return callback();
      }
      callback("密码必须包含⼤、小写字母、数字、特殊字符（四种⾥⾄少三种）");
    };

    return {
      captchaPath: '',
      //1登录。2注册。3忘记密码
      toggle: this.$store.state.dialogToggle,
      checked: false,
      options: regionData,
      fileList: [],
      selectedOptions: [],
      loginForm: {
        username: "",
        password: "",
      },
      registerForm: {
        nickname: "",
        passowrd: "",
        passowrd2: "",
        organizationCode: "",
        userRoleId: "2", //用户性质
        province: null, //省
        city: null, //市
        deptName: "",
        district: null, //区
        businessLicense: "",
        phone: "",
        businessLicenseThumbnail: "",
        businessLicense: "",
        verificationCode: "",
      },
      forgetPasswordForm: {
        phone: "",
        verificationCode: "",
        password: "",
        password2: "",
      },
      // 忘记密码规则
      forgetPasswordFormRules: {
        phone: [{ validator: checkPhone, trigger: "blur" }],
        verificationCode: [{ trigger: "blur" }],
        password: [{ validator: checkPassword, trigger: "blur" }],
        password2: [{ validator: checkPassword, trigger: "blur" }],
      },
      registerFormRules: {
        phone: [{ validator: checkPhone, trigger: "blur" }],
        verificationCode: [{ trigger: "blur" }],
      },
      dialogImageUrl: "",

      dialogVisible: false,
      placeholder: "请上传营业执照",
      publcKey: "", //公钥
      action: this.$store.state.axiosUrl + "/api/file/pb/upload",
      show: false,
      valiBtn: "获取验证码",
      valiBtnDisabled: false,
    };
  },
  mounted() {
    this.handleKey();
    this.getCaptcha()
  },
  methods: {
    getCaptcha () { // 验证码
      this.captchaPath = `${this.$store.state.axiosUrl}/api/captcha?d=${Math.random()}`;
    },
    // 去注册
    changeToggleToregister() {
      this.$store.commit("changeToggle", 2);
      this.toggle = this.$store.state.dialogToggle;
    },
    //去登陆
    changeToggleToLogin() {
      this.$store.commit("changeToggle", 1);
      this.toggle = this.$store.state.dialogToggle;
    },
    //忘记密码
    changeToggleToForgotPassword() {
      this.$store.commit("changeToggle", 3);
      this.toggle = this.$store.state.dialogToggle;
    },
    // 上传之前
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["jpg", "png"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.message({
          message: "上传文件只能是 jpg,png格式",
          type: "warning",
        });
        return false;
      }
    },
    // 上传放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传成功之后
    handleSuccess(file) {
      this.placeholder = "";
      this.registerForm.businessLicense = file.url;
      this.registerForm.businessLicenseThumbnail = file.smUrl;
    },
    //删除文件
    handleRemove() {
      this.placeholder = "请上传营业执照";
      this.fileList = [];
    },
    // 获取公钥
    handleKey() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/get/public/key",
      }).then((res) => {
        this.publcKey = res.data;
        sessionStorage.setItem("publcKey", res.data);
      });
    },
    //登录
    onSubmit() {
      let rule = /^1[3456789]\d{9}$/;
      console.log();
      console.log("this.loginForm.username", this.loginForm.username);
      if (!rule.test(this.loginForm.username)) {
        this.$message.error("手机号格式不正确");
      } else if (this.loginForm.password == "") {
        this.$message.error("密码不能为空");
      } else if (this.loginForm.captcha == "") {
        this.$message.error("验证码不能为空");
      } else {
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(this.publcKey);
        console.log(encrypt);
        let password = encrypt.encrypt(this.loginForm.password);
        console.log(
          "passwor",
          password,
          "this.loginForm.password",
          this.loginForm.password
        );
        let formData = new FormData();
        formData.append("password", password);
        formData.append("username", this.loginForm.username);
        formData.append("captcha", this.loginForm.captcha);
        formData.append("d", this.captchaPath.split('?d=')[1]);
        this.ajaxUtil({
          method: "post",
          url: this.$store.state.axiosUrl + "/api/login",
          data: formData,
        }).then((res) => {
          this.$message.success("登陆成功");
          this.$store.commit("changeDialog", false);
          this.$store.commit("setToken", res.access_token);
          this.getUserInfo();
        });
      }
    },
    getUserInfo() {
      // 获取用户信息
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/main/user",
      }).then((res) => {
        this.$store.dispatch("getUserInfo", res.data);
        if (res.data.currentRoleName == "企业用户") {
          this.getUserDeptInfo();
        }
      });
    },
    getUserDeptInfo() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/dept/getUserDeptInfo",
      }).then((res) => {
        this.$store.dispatch("getUserDeptInfo", res.data);
      });
    },
    // 省市区
    addressChoose(value) {
      this.registerForm.province = CodeToText[value[0]];
      this.registerForm.city = CodeToText[value[1]];
      this.registerForm.district = CodeToText[value[2]];
    },
    // 文件上传
    upload() {
      this.ajaxUtil({
        method: "post",
        url: this.$store.state.axiosUrl + "/api/file/pb/upload",
        data: this.fileList,
      }).then((res) => {
        console.log(res);
      });
    },
    register() {
      console.log("userRole", this.registerForm.userRoleId);
      let rule = /^1[3456789]\d{9}$/,
        pwdReg =
          /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8}$/;
      if (!this.checked) {
        this.$message.error("请先阅读并同意《注册协议》");
      } else if (this.registerForm.nickname == "") {
        this.$message.error("用户名不能为空");
      } else if (
        this.registerForm.deptName == "" &&
        this.registerForm.userRoleId == 4
      ) {
        this.$message.error("公司名称不能为空");
      } else if (!rule.test(this.registerForm.phone)) {
        this.$message.error("手机号格式不正确");
      } else if (this.registerForm.verificationCode == "") {
        this.$message.error("验证码不能为空");
      } else if (this.registerForm.passowrd == "") {
        this.$message.error("密码不能为空");
      } else if (this.registerForm.passowrd.length != 8) {
        this.$message.error("密码应为8位数密码");
      } else if (
        this.registerForm.passowrd.length == 8 &&
        !pwdReg.test(this.registerForm.passowrd)
      ) {
        // if (!pwdReg.test(this.registerForm.passowrd)) {
        //   this.$message.error(
        //     "密码必须包含⼤、小写字母、数字、特殊字符（四种⾥⾄少三种）"
        //   );
        // }
        this.$message.error(
          "密码必须包含⼤、小写字母、数字、特殊字符（四种⾥⾄少三种）"
        );
      } else if (this.registerForm.passowrd !== this.registerForm.passowrd2) {
        this.$message.error("两次密码输入不一致");
      } else if (
        this.registerForm.district == null &&
        this.registerForm.userRoleId == 4
      ) {
        this.$message.error("请选择地址");
      } else if (
        this.registerForm.organizationCode == "" &&
        this.registerForm.userRoleId == 4
      ) {
        this.$message.error("组织机构代码不能为空");
      } else if (
        this.placeholder == "请上传营业执照" &&
        this.registerForm.userRoleId == 4
      ) {
        this.$message.error("请上传营业执照");
      } else {
        this.ajaxUtil({
          method: "post",
          url: this.$store.state.axiosUrl + "/api/register",
          data: this.registerForm,
        }).then((res) => {
          this.$message.success("注册成功请登录！");
          this.changeToggleToLogin();

          this.registerForm = {
            nickname: "",
            passowrd: "",
            passowrd2: "",
            organizationCode: "",
            userRoleId: "4", //用户性质
            province: null, //省
            city: null, //市
            deptName: "",
            district: null, //区
            businessLicense: "",
            phone: "",
            businessLicenseThumbnail: "",
            businessLicense: "",
          };
          console.log("this.registerForm", this.registerForm);
        });
      }
    },
    forgetPassword() {
      let rule = /^1[3456789]\d{9}$/,
        pwdReg =
          /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8}$/;
      if (!rule.test(this.forgetPasswordForm.phone)) {
        this.$message.error("手机号格式不正确");
      } else if (this.forgetPasswordForm.verificationCode == "") {
        this.$message.error("验证码不能为空");
      } else if (this.forgetPasswordForm.password == "") {
        this.$message.error("密码不能为空");
      } else if (this.forgetPasswordForm.password.length != 8) {
        this.$message.error("密码应为8位数密码");
      } else if (
        this.forgetPasswordForm.password.length == 8 &&
        !pwdReg.test(this.forgetPasswordForm.password)
      ) {
        this.$message.error(
          "密码必须包含⼤、小写字母、数字、特殊字符（四种⾥⾄少三种）"
        );
      } else if (
        this.forgetPasswordForm.password !== this.forgetPasswordForm.password2
      ) {
        this.$message.error("两次密码输入不一致");
      } else {
        this.ajaxUtil({
          method: "GET",
          // data: fd,
          url:
            this.$store.state.axiosUrl +
            "/api/user/updatePssword?verificationCode=" +
            this.forgetPasswordForm.verificationCode +
            "&oldPsw=" +
            this.forgetPasswordForm.password2 +
            "&newPsw=" +
            this.forgetPasswordForm.password +
            "&phone=" +
            this.forgetPasswordForm.phone,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("密码找回成功请登录！");
            this.changeToggleToLogin();
            this.forgetPasswordForm = {
              phone: "",
              verificationCode: "",
              password: "",
              password2: "",
            };
          }else{
            this.$message.error(res.msg);
          }
        });
      }
    },
    //获取验证码
    //获取验证码 并只验证手机号 是否正确
    getCode() {
      // 忘记密码
      console.log("this.toggle", this.toggle);
      if (this.toggle == 3) {
        this.$refs["forgetPasswordForm"].validateField("phone", (err) => {
          console.log("in");
          if (err) {
            console.log("未通过");
            return;
          } else {
            console.log("已通过");
            this.tackBtn(); //验证码倒数60秒
            // let fd = new FormData(); //POST 请求需要 转化为Form
            // fd.append("phone", this.forgetPasswordForm.phone);
            this.ajaxUtil({
              method: "GET",
              url:
                this.$store.state.axiosUrl +
                "/api/user/getYzm?phone=" +
                String(this.forgetPasswordForm.phone),
            }).then((res) => {
              let newRes = JSON.parse(res.result);
              if (newRes.code == 0) {
                this.$message.success("验证码已发送");
              }
            });
          }
        });
        // 注册
      } else if (this.toggle == 2) {
        this.$refs["registerForm"].validateField("phone", (err) => {
          console.log("in");
          if (err) {
            console.log("未通过");
            return;
          } else {
            console.log("已通过");
            this.tackBtn(); //验证码倒数60秒
            // this.$message.success("验证码已发送");
            // let fd = new FormData(); //POST 请求需要 转化为Form
            // fd.append("phone", this.registerForm.phone);
            this.ajaxUtil({
              method: "GET",
              // data: fd,
              url:
                this.$store.state.axiosUrl +
                "/api/user/getYzm?phone=" +
                String(this.registerForm.phone),
            })
              .then((res) => {
                let newRes = JSON.parse(res.result);
                if (newRes.code == 0) {
                  this.$message.success("验证码已发送");
                }
              })
              .catch((err) => {
                console.log("接口或处理逻辑出错", err);
                // error
              });
          }
        });
      }
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.valiBtnDisabled = false;
        } else {
          this.valiBtnDisabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.myDialog {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 111;
  .login {
    width: 4.8em;
    background-color: rgba(#24a0ee, 0.2);
    border-radius: 10px;
    padding: 10px;
    .loginCenter {
      background-color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 20px;
      position: relative;
      .title {
        font-size: 25px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #2579bf;
      }
      //
      .demo-form-inline:last-child {
        border: none;
      }
      .demo-form-inline {
        margin-top: 50px;
        width: 80%;
        /deep/.el-form-item {
          border-bottom: 1px solid #cccccc;
          i {
            font-size: 18px;
            color: #ccc;
          }
        }
        /deep/.el-input__inner {
          border: none;
          border-radius: 0;

          width: 100%;
          padding-left: 0px;
          color: #333;
        }
        /deep/.el-select {
          width: 100%;
        }
      }
      .loginFooter {
        display: flex;
        width: 64%;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #215799;
        margin-top: 20px;
        span {
          cursor: pointer;
        }
      }
      .loginFooter-flex {
        justify-content: space-between !important;
      }
    }
  }
}
.el-button--primary {
  width: 80%;
  background-color: #2579bf;
  margin-top: 30px;
  padding: 15px;
  font-size: 18px;
}
.gotoLogin {
  font-size: 16px;
  color: #215799;
  margin-top: 20px;
}
// 上传样式
/deep/.el-upload.el-upload--picture-card {
  background-color: rgba(0, 0, 0, 0) !important;
  border: none;
  height: 50px;
  width: 40px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
/deep/.userType {
  width: calc(100% - 63px);
  margin: auto;
}
/deep/.userType .el-form-item__content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-left: 0px !important;
  margin: auto;
}
/deep/.userType .el-form-item__content::before {
  display: none !important;
}
/deep/.userType .el-form-item__content::after {
  display: none !important;
}
/deep/.el-upload-list__item.is-success {
  width: 60px;
  height: 60px;
  position: relative;
  right: 14em;
  bottom: 1.3em;
}
/deep/.el-upload-list__item {
  width: 60px;
  height: 60px;
  position: relative;
  right: 14em;
  bottom: 1.3em;
}
.upLoad {
  color: rgb(37, 121, 191);
  // background-color: #f00;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-dialog__body {
  img {
    width: 85% !important;
  }
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
/deep/.el-dialog__body {
  width: 80%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 注册协议
.dialogOpenBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dialogOpen {
  font-size: 0.1em;
}
.dialogContent {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 30%;
  color: #444;
  span {
    text-indent: 30px;
    margin: 5px 0;
  }
  .smallInfo {
    text-indent: 30px;
    color: #666 !important;
  }
  h4 {
    margin: 10px 0;
  }
}
/deep/.el-dialog__header {
  padding: 0 !important;
  color: #333 !important;
  font-weight: 600;
}
.close {
  position: absolute;
  right: 10px;
  font-size: 0.3em;
  color: #888;
  top: 5px;
  cursor: pointer;
}
// 忘记密码
// 验证码
.verificationCode-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.verificationCode-inner-right {
  .verificationBtn {
    width: 100px;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 12px;
    padding: 4px 0px 4px 0px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #2579bf;
  }
}

// 取消input的上下箭头
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogLogin.vue